var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1002.4)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#32CD32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25 1003.6c-13.112 0-23.781 10.667-23.781 23.779 1.49e-5 13.112 10.669 23.781 23.781 23.781s23.781-10.669 23.781-23.781c-1.5e-5 -13.112-10.669-23.779-23.781-23.779zm0 3.6114c11.16 0 20.168 9.0078 20.168 20.168-1.3e-5 11.16-9.0078 20.17-20.168 20.17-11.16 1e-4 -20.168-9.0097-20.168-20.17 1.27e-5 -11.16 9.0078-20.168 20.168-20.168z",
    color: "#000000",
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.61243 0 0 .61243 7.0239 405.45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32CD32",
    transform: "matrix(.91761 0 0 .91761 2.0598 1003)",
    d: "m10.641 5.4531c-0.59364 0-1.1877 0.22872-1.6426 0.68359l-2.8613 2.8613c-0.90975 0.90975-0.90975 2.3735 0 3.2832l12.719 12.719 6.1445 6.1445 6.1445-6.1445 22.204-22.204c0.90975-0.90975 0.90975-2.3735 0-3.2832l-2.8613-2.8613c-0.90975-0.90975-2.3735-0.90975-3.2832 0l-22.204 22.204-12.719-12.719c-0.45487-0.45487-1.047-0.68359-1.6406-0.68359z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circleCheck.ddbf6199.svg";
export { ForwardRef as ReactComponent };